import { NumericFormat as NumberFormat } from 'react-number-format';

export const MeasurementFormatDisplay = ({ value, suffix }: { value: string | number; suffix: string }) => {
  return <NumberFormat value={value} displayType={'text'} thousandSeparator={true} suffix=' Sq. Ft' />;
};
